import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function QuickMenu() {
  const navigate = useNavigate();
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <div className="hidden lg:flex fixed right-6 bottom-10 z-40 flex-col gap-3 items-end">
        <button
          type="button"
          aria-label="맨 위로"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className={`cursor-pointer flex h-12 w-12 items-center justify-center rounded-full bg-background-50 border border-background-300 text-xl text-foreground-800 transition-all duration-300 hover:bg-background-100 ${
            showTop ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3 pointer-events-none"
          }`}
        >
          <i className="ri-arrow-up-line"></i>
        </button>
      </div>

      <div className="lg:hidden fixed bottom-0 left-0 w-full z-40 bg-background-50 border-t border-background-200 px-4 py-3 flex items-center gap-3">
        <button
          type="button"
          onClick={() => navigate("/apply")}
          className="flex-1 cursor-pointer whitespace-nowrap rounded-full btn-gradient px-4 py-3 text-sm font-medium text-white"
        >
          <i className="ri-plant-line mr-1.5"></i>거봉포도 수확체험 신청
        </button>
        <button
          type="button"
          aria-label="맨 위로"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="cursor-pointer flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-background-100 text-xl text-foreground-800"
        >
          <i className="ri-arrow-up-line"></i>
        </button>
      </div>
    </>
  );
}